import * as React from 'react'
import '../styles/CustomAppBar.scss'
import '../styles/App-media.scss'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Menu from 'material-ui/svg-icons/navigation/menu'
import LeftArrow from 'material-ui/svg-icons/navigation/arrow-back'
import { connect, Dispatch } from 'react-redux'
import { ActionType, Actions } from '../actions/drawer'
import { StoreState } from '../reducers'
import images from '../images'
import { PublishedJobParams } from '../types'
import { setCompletedJob } from '../actions/setCompletedJob'
import { removeJobDetails } from '../actions/setJobDetails'
import { RouterAction, routerActions } from 'react-router-redux'
import { ROUTES } from '../constants/routes'
import { JobStatus } from '../types/enums'
import { isNullOrUndefined } from 'util';

interface CustomAppBarProps {
  isSigned: boolean
  publishedJobParams: PublishedJobParams
  completedJob: any
  providerId: string
  unreadMessagesCount: number
  allMessagesCount: number
  isBiddingInProgress: boolean
  isJobInProgress: boolean
  routePush: (location: string) => RouterAction
  openDrawer: () => ActionType
  onSetCompletedJob: (completedJob: any) => void
  onRemoveJobDetails: () => void
}

interface PassedProps extends React.Props<any> {
  isMenuShown: boolean
  isIconButtonsShown: boolean
  isChatIconShown?: boolean
  resetStore?: boolean
  getActiveJob?: () => void
  openDrawer?: () => void
}

interface CustomAppBarState {
  isChatIconShown:boolean
}

class CustomAppBar extends React.Component<CustomAppBarProps & PassedProps, CustomAppBarState> {
  constructor(props: any) {
    super(props)

    this.state = {
      isChatIconShown: !isNullOrUndefined(this.props.isChatIconShown) ? this.props.isChatIconShown : true
    }
  }

  componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true
  }

  goBack = () => {
    if (this.props.resetStore) {
      this.props.onRemoveJobDetails()
    }
    history.back()
  }

  openDrawer = () => {
    if (this.props.getActiveJob) {
      this.props.getActiveJob()
    }
    this.props.openDrawer()
  }

  openChat = () => {
    this.props.routePush(ROUTES.CHAT)
  }

  render() {
    let menuButtonClass = 'menuButton'
    return (
      <AppBar position="static" className="appbar" >
        <Toolbar
          style={{ justifyContent: 'center' }}
        >
          {
            this.props.isIconButtonsShown ?
              <ul className="button-list">
                {
                  this.props.isMenuShown ?
                    <IconButton
                      className={menuButtonClass}
                      aria-label="Menu"
                      onClick={this.openDrawer}
                    >
                      <Menu />
                    </IconButton>
                    :
                    <IconButton
                      className={menuButtonClass}
                      aria-label="Menu"
                      onClick={this.goBack}
                    >
                      <LeftArrow />
                    </IconButton>
                }
              </ul> : null
          }
          <Typography variant="title" className="flex">
            <div className="appbar-logo">
              <img src={images.toolbarLogo} alt="" />
            </div>
          </Typography>
          {
              (this.props.isBiddingInProgress || this.props.isJobInProgress) && this.state.isChatIconShown ?
              <IconButton
                style={{ left: '25%' }}
                className={`${menuButtonClass} chat-button`}
                aria-label="Menu"
                onClick={this.openChat}
              >
                <img
                  className="custom-img"
                  src={this.props.unreadMessagesCount > 0 ? images.chatIconNewMessages : images.chatIcon}
                />
              </IconButton>
              :
              null
          }
        </Toolbar>
      </AppBar>
    )
  }
}

function mapStatesToProps(store: StoreState) {
  return {
    isSigned: store.auth.isSigned,
    publishedJobParams: store.publishedJobParams,
    completedJob: store.completedJob,
    providerId: store.jobDetails.providerId,
    unreadMessagesCount: store.chat.newMessagesCounter,
    allMessagesCount: store.chat.messages.length,
    isBiddingInProgress: store.jobDetails.status == JobStatus.BIDDING_ACTIVE || store.jobDetails.status == JobStatus.CREATED || store.jobDetails.status == JobStatus.UNDER_REVIEW,
    isJobInProgress: (store.jobDetails.status == JobStatus.ACCEPTED || store.jobDetails.status == JobStatus.HAULER_ARRIVING || store.jobDetails.status == JobStatus.CONFIRM_ARRIVAL)

  }
}

function mapDisptachToProps(dispatch: Dispatch<ActionType>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    openDrawer: () => dispatch(Actions.open()),
    onSetCompletedJob: (completedJob: any) => dispatch(setCompletedJob(completedJob)),
    onRemoveJobDetails: () => dispatch(removeJobDetails())
  }
}

export const AppBarContainer = connect<{}, {}, PassedProps>(
  mapStatesToProps,
  mapDisptachToProps
)(CustomAppBar)



// WEBPACK FOOTER //
// ./src/containers/CustomAppBar.tsx